import React, { useEffect, useState } from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { useAuth0 } from "@auth0/auth0-react";

import { returnTextByOrg } from "../utils/textHelpers";

const NavBar = ({ hideCustomers, hideEmployees }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const toggle = () => setIsOpen(!isOpen);
  const [isOrgAdmin, setIsOrgAdmin] = useState(false);
  const [myOrgs, setMyOrgs] = useState([]);

  const org_admin = "Organization Administrator";

  const hostname = window.location.hostname;
  const splithostname = hostname.split(".");
  let subdomain = splithostname[0];
  let organization,
    connection = "";
  if (
    splithostname.length > 3 ||
    (splithostname.length > 1 && splithostname[1].includes("localhost"))
  ) {
    organization = connection = subdomain;
  }

  const splitOrigin = window.location.origin.split(`${subdomain}.`);
  const niscHome =
    subdomain === "niscpoc" || subdomain === "localhost"
      ? window.location.origin
      : splitOrigin.join("");

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });

  useEffect(() => {
    // console.log(user)
    if (isAuthenticated && "_org_roles" in user) {
      if ("_member_of_orgs" in user) {
        setMyOrgs(user._member_of_orgs);
      }
      setIsOrgAdmin(user._org_roles.includes(org_admin));
    }
  }, []);

  return (
    <>
      <style>
        {`
        .nav-container {
          // border: 1px red solid;
        }
        .login-buttons {
          // border: 1px green solid;
          display: flex !important;
          flex-direction: row !important;
          // width: 35%;
          justify-content: space-around;
        }
        .login-buttons > * {
          margin: 0 10px 0 10px;
        }

        img {
          width: 50px;
        }

        .linkcolor { 
          color: #44444c;
        }

        .navbar-toggler-icon {
          background: #44444c !important;
          height: 3px;
        }
        .navbar-toggler-icon:hover {
          background: yellow !important;
        }
      
      `}
      </style>
      <div className="nav-container">
        <Navbar color="light" expand="md" container={false}>
          <Container>
            <NavbarBrand className="logo mr-5">
              {returnTextByOrg(organization, {
                nisc: (
                  <img
                    src="./nisc.png"
                    style={{ height: "40px", width: "auto" }}
                  />
                ),
                southcentralpower: (
                  <img
                    src="./scp.jpg"
                    style={{ height: "60px", width: "auto" }}
                  />
                ),
                austinutilities: (
                  <img
                    src="./austinutilities.jpg"
                    style={{ height: "40px", width: "auto" }}
                  />
                ),
                oec: (
                  <img
                    src="./oec.png"
                    style={{ height: "40px", width: "auto" }}
                  />
                ),
              })}
            </NavbarBrand>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              <Nav className="mr-auto" navbar>
                <NavItem
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: "15px",
                  }}
                >
                  {/* <a href={window.location.origin} className="linkcolor">
                    Home
                  </a> */}
                  <NavLink
                      tag={RouterNavLink}
                      to="/"
                      exact
                      activeClassName="router-link-exact-active"
                      className="linkcolor"
                    >
                      Home
                    </NavLink>
                </NavItem>
                {isAuthenticated && (
                  <NavItem>
                    <NavLink
                      tag={RouterNavLink}
                      to="/permissions"
                      exact
                      activeClassName="router-link-exact-active"
                      className="linkcolor"
                    >
                      Permissions
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              <Nav>
                {isAuthenticated && myOrgs.length > 0 && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      id="profileDropDown"
                      className="linkcolor"
                    >
                      <b>{user && user._org_display_name}</b>
                    </DropdownToggle>
                    <DropdownMenu>
                      {myOrgs.map((org) => {
                        if (org.id !== user.org_id)
                          return (
                            <DropdownItem
                              onClick={() => {
                                localStorage.clear();
                                loginWithRedirect({
                                  authorizationParams: { organization: org.id },
                                });
                              }}
                              className="linkcolor"
                              key={`${org.id}`}
                            >
                              {org.display_name}
                            </DropdownItem>
                          );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
              </Nav>
              <Nav className="d-none d-md-block login-buttons" navbar>
                {!isAuthenticated && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      id="profileDropDown"
                      className="linkcolor"
                    >
                      Navigate
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => {
                          window.location.href = niscHome;
                        }}
                        className="linkcolor"
                      >
                        NISC
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          const tld = window.location.hostname.includes(
                            "localhost"
                          )
                            ? `localhost:${window.location.port}`
                            : `niscpoc.mvbuilt.com`;
                          window.location.href = `${window.location.protocol}//austinutilities.${tld}`;
                        }}
                        className="linkcolor"
                      >
                        Austin Utilities
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          const tld = window.location.hostname.includes(
                            "localhost"
                          )
                            ? `localhost:${window.location.port}`
                            : `niscpoc.mvbuilt.com`;
                          window.location.href = `${window.location.protocol}//southcentralpower.${tld}`;
                        }}
                        className="linkcolor"
                      >
                        South Central Power
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          const tld = window.location.hostname.includes(
                            "localhost"
                          )
                            ? `localhost:${window.location.port}`
                            : `niscpoc.mvbuilt.com`;
                          window.location.href = `${window.location.protocol}//oec.${tld}`;
                        }}
                        className="linkcolor"
                      >
                        Oklahoma Electric Cooperative
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
                {!isAuthenticated && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      id="profileDropDown"
                      className="linkcolor"
                      hidden={hideEmployees}
                    >
                      Employees
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => {
                          loginWithRedirect({
                            authorizationParams: {
                              "ext-origin": subdomain,
                              organization,
                              connection,
                            },
                          });
                        }}
                        className="linkcolor"
                      >
                        Log In
                      </DropdownItem>
                      {/* <DropdownItem
                        onClick={() => {
                          window.location.href = "/tenants";
                        }}
                        className="linkcolor"
                      >
                        Choose Tenant
                      </DropdownItem> */}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
                {!isAuthenticated && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      id="profileDropDown"
                      className="linkcolor"
                      hidden={hideCustomers}
                    >
                      End Consumer
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => {
                          loginWithRedirect({
                            authorizationParams: {
                              "ext-origin": subdomain,
                              organization,
                            },
                          });
                        }}
                        className="linkcolor"
                      >
                        Log In
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
                {!isAuthenticated &&
                  (subdomain === "niscpoc" || subdomain === "localhost") && (
                    <DropdownItem
                      onClick={() => {
                        loginWithRedirect();
                      }}
                      className="linkcolor"
                    >
                      General Login
                    </DropdownItem>
                  )}

                {isAuthenticated && (
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret id="profileDropDown">
                      <img
                        src={user.picture}
                        alt="Profile"
                        className="nav-user-profile rounded-circle"
                        width="50"
                      />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem header>{user.name}</DropdownItem>
                      <DropdownItem
                        tag={RouterNavLink}
                        to="/profile"
                        className="dropdown-profile"
                        activeClassName="router-link-exact-active"
                      >
                        <FontAwesomeIcon icon="user" className="mr-3" /> Profile
                      </DropdownItem>
                      {isAuthenticated && isOrgAdmin && (
                        <DropdownItem
                          id="qsOrgMgmtBtn"
                          tag={RouterNavLink}
                          to="/org"
                          className="dropdown-profile"
                          activeClassName="router-link-exact-active"
                        >
                          <FontAwesomeIcon icon="users" className="mr-3" />
                          Org Management
                        </DropdownItem>
                      )}
                      <DropdownItem
                        id="qsLogoutBtn"
                        onClick={() => {
                          logoutWithRedirect();
                          localStorage.clear();
                        }}
                      >
                        <FontAwesomeIcon icon="power-off" className="mr-3" />{" "}
                        Log out
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}
              </Nav>
              {/* {isAuthenticated && (
                <Nav
                  className="d-md-none justify-content-between"
                  navbar
                  style={{ minHeight: 170 }}
                >
                  <NavItem>
                    <span className="user-info">
                      <img
                        src={user.picture}
                        alt="Profile"
                        className="nav-user-profile d-inline-block rounded-circle mr-3"
                        width="50"
                      />
                      <h6 className="d-inline-block">{user.name}</h6>
                    </span>
                  </NavItem>
                  <NavItem>
                    <FontAwesomeIcon icon="user" className="mr-3" />
                    <RouterNavLink
                      to="/profile"
                      activeClassName="router-link-exact-active"
                    >
                      Profile
                    </RouterNavLink>
                  </NavItem>
                  <NavItem>
                    <FontAwesomeIcon icon="power-off" className="mr-3" />
                    <RouterNavLink
                      to="#"
                      id="qsLogoutBtn"
                      onClick={() => logoutWithRedirect()}
                    >
                      Log outs
                    </RouterNavLink>
                  </NavItem>
                </Nav>
              )} */}
            </Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default NavBar;
